import { Events } from '|>/shared/events'
import { Intent } from '|>/shared/types/intent'
import { on, register } from '|>/shared/vjs'
import { BaseButton } from '../base'

import './play-previous.css'

/**
 * Play next button component
 */
@register
export class PlayPrevious extends BaseButton {
  @on(Events.Controls.ShowPlayPreviousControl)
  changeVisibility(visible: Events.Controls.ShowPlayPreviousControl) {
    if (visible) this.show()
    else this.hide()
  }

  override handleClick(event: MouseEvent) {
    event.stopPropagation()
    this.player_.trigger(Events.User.Intent, Intent.PlayPrevious)
    this.player_.trigger(Events.Player.PlayPrevious)
  }
}

PlayPrevious.options = {
  className: 'vjs-x-prev-button',
}
